import { observable } from "mobx";
import Model from "./Model";

export default class Audio extends Model {
  /**
   * @property {number|string}
   */
  @observable audioId = 0;

  @observable name = null;

  @observable compactDescription = null;

  @observable audioPathWeb = null;
}
